import React, { useEffect, useState, Fragment, useRef } from 'react';
import { Button, DatePicker, Pagination,  Form, notification, Table, Select, Tag } from 'antd';
import * as Actions from '../../../libs/actions';
import { connect } from 'react-redux';
import moment from 'moment';
import viVN from 'antd/es/date-picker/locale/vi_VN';
import * as Statistic from '../../../services/statisticService';
import * as ConfigService from '../../../services/configService';
import * as SystemConfig from "../../../configure/systemConfig";

const { RangePicker } = DatePicker;
const { Option } = Select;
function StatisticMarketing(props) {
    const _hiddenLink = useRef()
    const [date, setDate] = useState([moment(), moment()]);
    const [dataSource, setDataSource] = useState([]);
    const [page, setPage] = useState(1);
    const [size, setSize] = useState(10);
    const [totalRecord, setTotalRecord] = useState(0);
    const [filter, setFilter] = useState('');
    const [siteId,] = useState(props.siteid);
    const [lstMarketing , setLstMarketing] = useState([]);

    useEffect(() => {
        GetThongKeKenhKhachHang();
    }, [date, page, size, filter])

    useEffect(()=> {
        GetKenhKhachHang()
    },[])

    const GetThongKeKenhKhachHang = () => {
        Actions.setLoading(true);
        Statistic.ThongKeKenhKhachHang(date[0].format("yyyy/MM/DD"), date[1].format("yyyy/MM/DD"), page, size, siteId, filter).then(res => {
            if (res.isSuccess) {
                setDataSource(res.data);
                setTotalRecord(res.totalRecords);
            }
        }).catch(() => {
        }).finally(() => {
            Actions.setLoading(false);
        })
    }

    const ExportThongKeKenhKhachHang = () => {
        Actions.setLoading(true);
        Statistic.ExportThongKeKenhKhachHang(date[0].format("yyyy/MM/DD"), date[1].format("yyyy/MM/DD"), siteId,filter).then((response) => {
            response.blob().then((blob) => {
                let url = window.URL.createObjectURL(blob);
                _hiddenLink.current.href = url;
                let fileName = `${moment().format(SystemConfig.FORMAT_PREFIX_EXCEL)}_DSKH_KenhKH`; 
                _hiddenLink.current.download = fileName;
                _hiddenLink.current.click();
            })
        }).catch(err => {
            Actions.openMessageDialog("Thông báo", err?.error?.extensionData ?? "Đã xảy ra lỗi tải xuống");
        }).finally(() => {
            Actions.setLoading(false);
        })
    }

    const GetKenhKhachHang = () => {
        Actions.setLoading(true);
        ConfigService.GetKenhKhachHang(1, 100,false).then(result => {
            if (result.isSuccess) {
                setLstMarketing(result.data)
            } else {
                notification.warning({ message: result.err.msgString });
            }
        }).catch(err => {
            Actions.openMessageDialog("Lỗi", err);
        }).finally(() => {
            Actions.setLoading(false);
        })
    }

    const columns = [
        {
            title: "STT",
            align: "center",
            render: (text, record, index) => (page - 1) * size + Number(index) + 1,
            width: 70
        },
        {
            title: "Mã bệnh nhân",
            dataIndex: "id",
            key: "id",
            align: "center",
            width: 100,
        },
        {
            title: "Tên bệnh nhân",
            dataIndex: "hoten",
            key: "hoten",
            align: "left",
            width: 150,
        },
        {
            title: "Giới tính",
            dataIndex: "gioitinh",
            key: "gioitinh",
            align: "center",
            width: 90,
        },
        {
            title: "Năm sinh",
            dataIndex: "namsinh",
            key: "namsinh",
            align: "center",
            width: 90,
        },
        {
            title: "Nguồn khách hàng",
            dataIndex: "coporator",
            key: "coporator",
            align: "left",
            width: 200,
        },
        {
            title: "Điện thoại",
            dataIndex: "dienthoai",
            key: "dienthoai",
            align: "left",
            width: 110,
        },
        {
            title: "Kênh khách hàng",
            dataIndex: "marketing",
            key: "marketing",
            align: "left",
            width: 200,
        },
        {
            title: "Ngày",
            dataIndex: "ngay",
            key: "ngay",
            align: "left",
            width: 200,
            render: (row) => {
                return <span>{moment(row).format(SystemConfig.FORMAT_DATE_TIME)}</span>
            }
        }
    ];

    return (
        <Fragment>
            <a href="#download" style={{ display: 'none' }} ref={_hiddenLink} ></a>
            <div className='containerChilderWrapper'>
                <div className='h4 text-center mt-2 font-bold text-uppercase'>Thống kê kênh khách hàng</div>
                <div className="d-flex justify-content-center my-1">
                    <div style={{ width: 200 }} className="mr-2 mt-1">
                        <Form.Item>
                            <Select
                                style={{ width: '200px' }}
                                showSearch
                                allowClear={false}
                                value={filter}
                                onChange={(e) => {
                                    setFilter(e)
                                    setPage(1)
                                }}
                                filterOption={(input, option) =>
                                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                            >
                                <Option key={0} value={''}>Tất cả kênh khách hàng</Option>
                                {lstMarketing && lstMarketing.map((item, index)=>{
                                    return(
                                        <Option key={index} value={item.id}>{item.ten}</Option>
                                    )})
                                }
                            </Select>
                        </Form.Item>
                    </div>
                    <div className="mr-2 mt-1">
                        <RangePicker allowClear={false} format="DD-MM-YYYY" value={date} locale={viVN}
                            onChange={(value => setDate(value))}
                        />
                    </div>
                    {/* <div style={{ width: 350 }} className="mr-2">
                        <Input value={key} placeholder="Thích gì nhập đó, tìm được hay không là do ăn ở"
                            onChange={(e) => setKey(e.target.value)}
                        />
                    </div> */}
                    <div className="d-flex mt-1">
                        <Button className="btn btn-color"
                            onClick={() => {GetThongKeKenhKhachHang()}}>
                            <i style={{ marginRight: 5 }} className="fa fa-search" />Tìm
                        </Button>
                        <Button className="btn btn-color" style={{ marginLeft: 10 }} onClick={() => {ExportThongKeKenhKhachHang() }}> <i style={{ marginRight: 5 }} className="fas fa-download" />Xuất excel</Button>
                    </div>
                </div>
                <div style={{ width: "100%", height: 'calc(100% - 120px)', marginTop: 20 }}>
                    <Table
                        scroll={{ y: 0, x: 'max-content' }}
                        dataSource={dataSource}
                        columns={columns}
                        pagination={false}
                        rowKey={(row, index) => index}
                    />
                </div>
                <Pagination
                    style={{ textAlignLast: 'center', marginTop: 10, marginBottom: 10 }}
                    total={totalRecord}
                    showTotal={total => `Tổng: ${total}`}
                    size={size}
                    current={page}
                    onChange={(page, size) => {
                        setPage(page);
                        setSize(size);
                    }}
                    onShowSizeChange={(page, size) => {
                        setPage(1);
                        setSize(size);
                    }}
                    showSizeChanger={true}
                />
            </div>
        </Fragment>
    );
}

const mapStateToProps = (state) => {
    return ({
        siteid: state.global.siteid,
        siteCode: state.global.siteCode
    })
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(StatisticMarketing)